import InputText from '@rsos/components/capstone/base/form/inputs/InputText';
import FieldLabel from './FieldLabel';
import styles from './NorfolkSouthernForm.module.css';
import {
  visibleFieldError,
  type NorfolkSouthernFormik,
} from './formFieldUtils';

interface OriginDateFieldProps {
  formik: NorfolkSouthernFormik;
}

/** The date the train departed its origin, which Norfolk Southern looks the run up by. */
function OriginDateField({ formik }: OriginDateFieldProps): JSX.Element {
  return (
    <div className={styles.field}>
      <FieldLabel required>Origin Date</FieldLabel>
      <InputText
        id="originDate"
        name="originDate"
        type="date"
        setFieldValue={formik.setFieldValue}
        value={formik.values.originDate}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={visibleFieldError(formik, 'originDate')}
        style={{ fontSize: '14px' }}
      />
      <div
        className={styles.helperText}
        data-name="norfolk-southern-origin-date-help"
      >
        Read from the train ID when it includes one. Correct it if the train
        departed on another date.
      </div>
    </div>
  );
}

export default OriginDateField;
